<template>
  <span>
    <a-modal v-model="visible" :width="640" title="推送质效看板消息" :ok-button-props="{ props: { loading: loading } }" @cancel="visible = true" @ok="onSubmit">
      <a-form-model ref="form" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="推送群聊" prop="chat_ids">
          <a-select v-model="form.chat_ids" mode="multiple" placeholder="请选择推送消息的群聊">
            <a-spin v-if="spinning" slot="notFoundContent" size="small" />
            <a-select-option v-for="(chat, index) in chatList" :key="index" :value="chat.chat_id"> {{ chat.name }} ({{ chat.chat_id }})</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="备注信息" prop="description">
          <a-textarea v-model="form.description" :placeholder="placeholder" :rows="6" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-button v-tc="{ name: '推送消息' }" type="primary" @click="onPush"> 推送消息 </a-button>
  </span>
</template>

<script>
import { feiShuChatList } from '@/api/system/service';
import { noticeboardSendMessage } from '@/api/data/noticeboard';
export default {
  props: {
    sourceId: {
      type: [String, Number],
      default: null
    },
    sourceData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      spinning: false,
      chatList: [],
      form: {
        chat_ids: [],
        description: null
      },
      rules: {
        chat_ids: [{ required: true, message: '推送群聊不能为空', trigger: 'blur' }]
      },
      placeholder: null,
      labelCol: { span: 4 },
      wrapperCol: { span: 18 }
    };
  },
  methods: {
    onPush() {
      this.visible = true;
      this.loading = false;
      this.form = {
        chat_ids: [],
        description: null
      };
      this.placeholder = this.sourceData.description;
      this.getFeiShuChatList();
    },
    getFeiShuChatList() {
      this.spinning = true;
      feiShuChatList({})
        .then(response => {
          this.chatList = response.data.items;
          this.spinning = false;
        })
        .catch(() => {
          this.spinning = false;
        });
    },

    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          noticeboardSendMessage({ id: this.sourceId, ...this.form })
            .then(() => {
              this.$message.success('消息发送成功');
              this.loading = false;
              this.visible = false;
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>
